export default {
  common: {
    locationSearch: {
      placeHolder: "Search by Location",
    },
    filters: {
      label: "Filters",
      selected: "{count} selected",
      channel: "Type",
      groupType: "Property Group Type",
      date: "Posted Date",
      search: "Show properties",
    },
    emptyHeader: "We couldn't find any properties that match your refinements.",
    emptySubHeader:
      "Try changing your criteria to find the property you are after.",
  },
};
